import React, { useContext } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const AdminLayout = () => {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();         // Clear token & state
    navigate("/login");     // Redirect to login page
  };

  return (
    <div className="d-flex" style={{ minHeight: "100vh" }}>
      {/* Sidebar */}
      <aside
        className="bg-dark text-white p-3"
        style={{ width: "250px", minHeight: "100vh" }}
      >
        <h4 className="text-center mb-4">🛒 Admin Panel</h4>
        <ul className="nav flex-column">
          <li className="nav-item">
            <Link className="nav-link text-white" to="/admin">
              <i className="bi bi-speedometer2 me-2" />
              Dashboard
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link text-white" to="/admin/products">
              <i className="bi bi-box-seam me-2" />
              Products
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link text-white" to="/admin/categories">
              <i className="bi bi-tags me-2" />
              Categories
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link text-white" to="/admin/orders">
              <i className="bi bi-cart-check me-2" />
              Orders
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link text-white" to="/admin/users">
              <i className="bi bi-people me-2" />
              Users
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link text-white" to="/admin/company-info">
              <i className="bi bi-people me-2" />
              Company Info
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link text-white" to="/admin/header-banner">
              <i className="bi bi-people me-2" />
              Banner
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link text-white" to="/admin/brands">
              <i className="bi bi-people me-2" />
              Brands
            </Link>
          </li>
        </ul>
      </aside>

      {/* Main Content */}
      <div className="flex-grow-1">
        {/* Top Header */}
        <nav className="navbar navbar-expand navbar-light bg-light shadow-sm px-4">
          <div className="container-fluid">
            <span className="navbar-brand">Admin Dashboard</span>
            <div className="ms-auto d-flex align-items-center gap-3">
              <span className="text-muted">👤 Admin</span>
              <button className="btn btn-outline-danger btn-sm" onClick={handleLogout}>
                🚪 Logout
              </button>
            </div>
          </div>
        </nav>

        {/* Main Body */}
        <main className="p-4">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
